export class RoleDto {
    id: number = 0;
    role: string = '';
    description: string = '';
}